/** Route definitions for the learner feature zone. */
import { Routes, Route } from 'react-router-dom';
import LearnerHome from './home/LearnerHome';
import LearnerHomeConcepts from './home/LearnerHomeConcepts';
import InvitingHomeMockup from './home/InvitingHomeMockup';
import { DiscoverPage } from './discover';
import LessonsPage from './lessons/LessonsPage';
import FolderPage from './lessons/FolderPage';
import CoursePage from './course/CoursePage';
import MyCoursesPage from './home/MyCoursesPage';
import { RevisionPage, RevisionHistoryPage } from './revision';
import SettingsPage from './settings/SettingsPage';
import DesignTestingPage from './designsystem/DesignTestingPage';
import DesignSystemPage from './designsystem/DesignSystemPage';

export function LearnerRoutes() {
  return (
    <Routes>
      <Route index element={<LearnerHome />} />
      <Route path="home-lab" element={<LearnerHomeConcepts />} />
      <Route path="identity-mockup" element={<InvitingHomeMockup />} />
      <Route path="identity-mockup/:conceptId" element={<InvitingHomeMockup />} />
      <Route path="courses/:courseId" element={<CoursePage />} />
      <Route path="my-courses" element={<MyCoursesPage />} />
      <Route path="lessons" element={<LessonsPage />} />
      <Route path="lessons/:folderSlug" element={<FolderPage />} />
      <Route path="discover" element={<DiscoverPage />} />
      <Route path="revision" element={<RevisionPage />} />
      <Route path="revision/history/:sessionId" element={<RevisionHistoryPage />} />
      <Route path="settings" element={<SettingsPage />} />
      <Route path="designtesting" element={<DesignTestingPage />} />
      <Route path="designsystem" element={<DesignSystemPage />} />
    </Routes>
  );
}
